import { render } from "./AppVersionLabel.vue?vue&type=template&id=bb0db2de&scoped=true"
import script from "./AppVersionLabel.vue?vue&type=script&lang=js"
export * from "./AppVersionLabel.vue?vue&type=script&lang=js"

import "./AppVersionLabel.vue?vue&type=style&index=0&id=bb0db2de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0db2de"]])

export default __exports__